import * as types from "./../types";
import OtpService from "../../services/Otp.Service";
import { funcUpdateAppStateAfterResponse } from "./AppStateActions";

const initState = {
  isSaved: true,
  currentAction: "",
  isSubmited: false,
  isSubmitedSuccess: false,
  //screenName: "",
  loading: false,
  error: null,
};
let payload = {};
let errorState = {};

export const funcGenerateOtp =
  (inputData, screenName, currentAction, resendFlag, reasonCode = "101") => async (dispatch) => {
    dispatch({
      type: types.LOADING_VIEW_STATE,
      value: true,
    });
    const response = await OtpService.funcGenerateOtp(inputData, reasonCode);
    if (response && response.data) {
      if (response.data.statusCode === "000") {
        if (!resendFlag) {
          payload = {
            ...initState,
            currentAction,
            isSubmited: true,
            isSubmitedSuccess: true,
            // screenName: screenName,
            loading: false,
          };
        } else {
          payload = {
            ...initState,
            currentAction,
            // screenName: screenName,
            loading: false,
          };
        }
        errorState = null;
      } else {
        // if (response.data.statusCode === "999") {
        payload = {
          ...initState,
          currentAction,
          isSubmited: true,
          isSubmitedSuccess: false,
          // screenName: screenName,
          loading: false,
        };
        errorState = {
          errorCode: response.data.statusCode,
          errorMsg: response.data.message,
        };
      }
    } else {
      payload = {
        ...initState,
        currentAction, //: "OtpSend",
        isSubmited: true,
        isSubmitedSuccess: false,
        // screenName: screenName,
        loading: false,
        error: response?.data?.message,
      };
    }
    dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
  };

export const funcClearOtpResponseOnEdit = () => async (dispatch) => {
  payload = {
    ...initState,
    isSaved: false,
    currentAction: "SavePersDetails",
    screenName: "personalDetails",
  };

  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
};
